import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-auth-hero-section',
  standalone: true,
  templateUrl: './auth-hero-section.component.html',
  styleUrl: './auth-hero-section.component.scss',
  host: {
    class: 'hero-section',
  },
})
export class AuthHeroSectionComponent {
  @Input() title =
    'Simplifies And Automates Vendor Interactions With Government Organizations.';
  @Input() footer = 'Everything the vendor lifecycle needs, in one coordinated system.';
}

